/* eslint-disable max-len */
define({
    root: ({
      errorIconAltText: 'Error Icon',
      warningIconAltText: 'Warning Icon',
      infoIconAltText: 'Information Icon',
      questionIconAltText: 'Question Icon',
      successIconAltText: 'Success Icon'
    })
  });